import React from "react";

const About = () => {
  return (
    <section className="section about-section">
      <h1 className="section-title">about us</h1>
      <p>
        Lorem ipsum lorem ipsum ASDFASDFASDFASD asdfasfdsdfsf asdrdwedfgg
        sdrsdrfsrwh dsd fdsfsdf rtrty p ewrwe trete wsewg g importsdfsd frt
        ferter er retrty6wefsdt serd gdfgdf sdfsesf
      </p>
    </section>
  );
};

export default About;
